<template>
  <div class="singleDisbursementModal">
    <h2 class="payout-second-title">{{ $t('merchantAccount.beneficiary_details') }}</h2>
    <div class="form-container">
      <el-form ref="singleDisbursementForm" :model="singleDisbursementForm" status-icon label-position="top">
        <el-row>
          <el-col v-if="showReceivingChannel">
            <el-form-item
              :label="$t('merchantAccount.receiving_channel')"
              prop="code"
              :rules="[
                { required: true, message: 'Receiving channel cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.code" placeholder="Select receiving channel" filterable class="select-item" clearable @change="disbursementChannelChange">
                <el-option
                  v-for="(item,index) in receivingChannelList"
                  :key="index"
                  :label="item.name_with_full_bank"
                  :value="item.bank_code"
                  :alt="item.name_with_full_bank"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="showBeneficiaryAccountType">
            <el-form-item
              :label="$t('merchantAccount.beneficiary_account_type')"
              prop="beneficiary_account_type"
              :rules="[
                { required: true, message: 'Beneficiary account type cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.beneficiary_account_type" placeholder="Select beneficiary account type" filterable class="select-item" clearable @change="beneficiaryAccountTypeChange">
                <el-option
                  v-for="(item,index) in beneficiaryAccountType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :alt="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--收款人类别 - 泰国 PROMPTPAY 或 阿联酋钱包类型-->
          <el-col v-if="showBeneficiaryType">
            <el-form-item
              :label="beneficiaryTypeLabel"
              prop="beneficiary_type"
              :rules="[
                { required: true, message: 'Beneficiary type cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.beneficiary_type" placeholder="Select beneficiary type" filterable class="select-item" clearable @change="beneficiaryTypeChange">
                <el-option
                  v-for="(item,index) in beneficiaryTypeOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :alt="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="isRUCountry">
            <el-form-item
              :label="$t('merchantAccount.beneficiary_category')"
              prop="beneficiary_category"
              :rules="[
                { required: true, message: $t('merchantAccount.beneficiary_category_required'), trigger: 'change' }
              ]"
            >
              <el-select v-model="singleDisbursementForm.beneficiary_category" :placeholder="$t('merchantAccount.beneficiary_category_placeholder')" filterable class="select-item" clearable>
                <el-option
                  v-for="item in beneficiaryCategoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_name')"
              prop="account_name"
              :rules="[
                { required: true, message: 'Beneficiary Name cannot be empty', trigger: 'blur'},
                { validator: checkWhitespace, trigger: 'blur'}
              ]"
            >
              <el-input v-model="singleDisbursementForm.account_name" placeholder="Enter beneficiary name" class="search-frame" autocomplete="off" clearable maxlength="40" show-word-limit />
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_account_no')"
              prop="account_no"
              :rules="[
                { required: true, message: 'Beneficiary Account No. cannot be empty', trigger: ['blur','change']},
                { validator: checkoutAccountNo, trigger: ['blur','change']}
              ]"
            >
              <el-input v-model="singleDisbursementForm.account_no" placeholder="Enter beneficiary account no." class="search-frame" autocomplete="off" clearable maxlength="50" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$t('customerService.beneficiary_mobile')"
              prop="mobile"
              :rules="[
                { required: $store.getters.curCountry.country_code === 'ID', message: 'Please input the correct mobile', trigger: ['blur', 'change'] },
                { validator: checkMobile, trigger: ['blur','change'] }
              ]"
            >
              <el-input v-model.trim="singleDisbursementForm.mobile" placeholder="Enter beneficiary mobile" class="search-frame" autocomplete="off" clearable :maxlength="getStandardPaymentLimitMapMobileLength($store.getters.curCountry.country_code)" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$t('customerService.email_address')"
              prop="email"
              :rules="[
                { type: 'email', message: 'Please input the correct email', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input v-model.trim="singleDisbursementForm.email" placeholder="Enter email address" class="search-frame" autocomplete="off" maxlength="50" clearable />
            </el-form-item>
          </el-col>
          <!--受益人地址-->
          <el-col v-if="$store.getters.curCountry.country_code === 'AE'">
            <el-form-item
              :label="$t('map.benefit_address')"
              prop="beneficiary_address"
              :rules="[
                { required: true, message: 'Beneficiary address cannot be empty', trigger: ['blur','change']},
                { trigger: ['blur','change']}
              ]"
            >
              <el-input
                v-model="singleDisbursementForm.beneficiary_address"
                :placeholder="$t('tips.beneficiary_address_name_exceed_140')"
                type="textarea"
                :rows="3"
                autocomplete="off"
                maxlength="140"
                show-word-limit
              />
            </el-form-item>
          </el-col>

          <!--海湾六国收款人信息-->
          <template v-if="isGulfCountry">
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_iban')"
                prop="iban"
                :rules="[
                  { required: true, message: 'Beneficiary IBAN cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model.trim="singleDisbursementForm.iban" placeholder="Enter beneficiary IBAN" class="search-frame" autocomplete="off" maxlength="100" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_swift_code')"
                prop="swift_code"
                :rules="[
                  { required: true, message: 'SWIFT Code cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model.trim="singleDisbursementForm.swift_code" placeholder="Enter SWIFT code" class="search-frame" autocomplete="off" maxlength="50" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_bank_address')"
                prop="bank_address"
                :rules="[
                  { required: true, message: 'Beneficiary bank address cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singleDisbursementForm.bank_address" placeholder="Enter beneficiary bank address" class="search-frame" autocomplete="off" maxlength="200" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_en_first_name')"
                prop="en_first_name"
                :rules="[
                  { required: true, message: 'Beneficiary English first name cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singleDisbursementForm.en_first_name" placeholder="Enter beneficiary English first name" class="search-frame" autocomplete="off" maxlength="100" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_en_last_name')"
                prop="en_last_name"
                :rules="[
                  { required: true, message: 'Beneficiary English last name cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singleDisbursementForm.en_last_name" placeholder="Enter beneficiary English last name" class="search-frame" autocomplete="off" maxlength="100" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_native_first_name')"
                prop="local_first_name"
                :rules="[
                  { required: true, message: 'Beneficiary native first name cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singleDisbursementForm.local_first_name" placeholder="Enter beneficiary native first name" class="search-frame" autocomplete="off" maxlength="100" clearable />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                :label="$t('merchantAccount.beneficiary_native_last_name')"
                prop="local_last_name"
                :rules="[
                  { required: true, message: 'Beneficiary native last name cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singleDisbursementForm.local_last_name" placeholder="Enter beneficiary native last name" class="search-frame" autocomplete="off" maxlength="100" clearable />
              </el-form-item>
            </el-col>
          </template>

          <el-col>
            <div>
              <h2 class="payout-second-title mt-12">{{ $t('merchantAccount.payment_details') }}</h2>
            </div>
          </el-col>

          <!-- 商户订单号 -->
          <el-col>
            <el-form-item
              :label="$t('merchantAccount.merchant_order_id')"
              prop="merchant_order_id"
            >
              <el-input
                v-model.trim="singleDisbursementForm.merchant_order_id"
                maxlength="32"
                show-word-limit
                placeholder="Enter merchant order ID"
                type="text"
                class="search-frame"
                autocomplete="off"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item
              :label="amountTips"
              prop="amount"
              :rules="[
                { required: true, message: 'Amount cannot be empty', trigger: ['blur','change']},
                { validator: checkAmount, trigger: ['blur','change'] }
              ]"
            >
              <el-input v-model.trim="singleDisbursementForm.amount" type="text" placeholder="Enter amount" class="search-frame" autocomplete="off" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('merchantAccount.payment_remark') + ':'"
              prop="remark"
              :rules="[
                { required: $store.getters.curCountry.country_code === 'AE', message: 'Payment remark cannot be empty', trigger: ['blur', 'change'] }
              ]"
            >
              <el-input
                v-model="singleDisbursementForm.remark"
                placeholder="Enter your message here"
                type="textarea"
                autocomplete="off"
                maxlength="256"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="$store.getters.isOpenMfa">
          <el-col :span="24">
            <el-form-item
              :label="$t('system.mfa_verify_code')"
              prop="mfa_code"
              :rules="[{ validator: validateVerifyCode, trigger: ['blur', 'change'] }]"
              required
            >
              <el-input
                v-model="singleDisbursementForm.mfa_code"
                maxlength="6"
                class="input-password"
                placeholder="Enter your MFA verification code"
                autocomplete="off"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="cp-btn">
      <el-button class="cancel-btn" @click="onClickCancelBtn">{{ $t('components.cancel') }}</el-button>
      <el-button class="confirm-btn" type="info" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
    </div>
  </div>
</template>

<script>
import { addSingleDisbursement, fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { fetchDisbursementAllCodeList } from '@/api/components/components.js'
import { beneficiaryAccountType, beneficiaryType } from '@/utils/maps'
export default {
  name: 'SingleStandardPayoutCreateContent',
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.BANK = 1
    this.checkWhitespace = (rule, value, callback) => {
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      callback()
    }

    this.checkMobile = (rule, value, callback) => {
      if (this.$store.getters.curCountry.country_code !== 'ID' && !value) {
        return callback()
      }
      if (value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }
      switch (this.$store.getters.curCountry.country_code) {
        case 'PH':
          if (!/^09[0-9]{9}$/.test(value)) {
            return callback(new Error('Please enter the 11 numbers starting with 09'))
          }
          break
        case 'TH':
          if (!/^0([689]\d{8})$/.test(value)) {
            return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
          }
          break
        case 'ID':
          if (!/^(08[0-9]{8,11})$/.test(value)) {
            return callback(new Error('Please enter the 10-13 numbers starting with 08'))
          }
          break
        case 'AE':
        case 'SA':
        case 'QA':
        case 'KW':
        case 'OM':
        case 'BH':
          if (!/^05\d{8}$/.test(value)) {
            return callback(new Error('Please enter the 10 numbers starting with 05'))
          }
          break
        case 'MY':
          if (!/^01\d{8,9}$/.test(value)) {
            return callback(new Error('Please enter the 10-11 numbers starting with 01'))
          }
          break

        default:
          break
      }
      callback()
    }

    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      //  根据不同国家限额不同设置对应规则
      const standardPaymentLimit = this.standardPaymentLimitMap(this.$store.getters.curCountry.country_code)
      if (standardPaymentLimit && standardPaymentLimit.minAmount && value < standardPaymentLimit.minAmount) {
        return callback(new Error(this.$t('send_pagements.standard_payment_min_amount', { amount: standardPaymentLimit.minLabel })))
      }
      if (standardPaymentLimit && value > standardPaymentLimit.amount) {
        return callback(new Error(`Currently up to ${standardPaymentLimit.label}`))
      }
      this.$commonFn.validateFormAmount({ rule, value, callback })
      if (value > this.$commonFn.mathDivide(this.balance, 100)) {
        return callback(new Error('Insufficient balance!'))
      }
      callback()
    }

    this.checkoutAccountNo = (rule, value, callback) => {
      const bankItem = this.bankList.find(item => item.bank_code === this.singleDisbursementForm.code) || {}
      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      if (this.$store.getters.curCountry.country_code === 'AE') {
        if (!/^[a-zA-Z0-9]+$/.test(value)) {
          return callback(new Error('Only letters and numbers are allowed'))
        }
      } else {
        if (value !== '0' && !Number(value)) {
          return callback(new Error('Only can input number'))
        }
      }
      const { beneficiary_account_type, beneficiary_type } = this.singleDisbursementForm
      // RU: SBP + MOBILE_NUMBER 时，账号必须为 9 开头的 10 位数字
      if (this.isRUCountry && beneficiary_account_type === 'SBP' && beneficiary_type === 'MOBILE_NUMBER' && !/^9\d{9}$/.test(value)) {
        return callback(new Error('Please enter a 10-digit account number starting with 9'))
      }
      if (bankItem.bank_type === 2 || (beneficiary_account_type === 'PROMPTPAY' && beneficiary_type === 'MOBILE_NUMBER')) {
        switch (this.$store.getters.curCountry.country_code) {
          case 'PH':
            if (!/(09)\d{9}$/.test(value)) {
              return callback(new Error('Please input the correct beneficiary account number which start with 09'))
            }
            break
          case 'TH':
            if (beneficiary_account_type === 'PROMPTPAY' && beneficiary_type === 'MOBILE_NUMBER' && !/^0([689]\d{8})$/.test(value)) {
              return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
            }
            break
          case 'ID':
            if (!/^(08[0-9]{8,11})$/.test(value)) {
              return callback(new Error('Please enter the 10-13 numbers starting with 08'))
            }
            break
          case 'AE':
            // 阿联酋国家钱包类型 + 手机号，校验手机号格式：10位数字，以05开头
            if (beneficiary_type === 'MOBILE_NUMBER' && !/^05\d{8}$/.test(value)) {
              return callback(new Error('The wallet account number must be 10 digits starting with 05'))
            }
            break
          case 'SA':
            if (!/^05\d{8}$/.test(value)) {
              return callback(new Error('The wallet account number must be 10 digits starting with 05'))
            }
            break

          default:
            break
        }
      }
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      if (value.length && value.length < 5) {
        return callback(new Error('Please input between 5 to 50 characters.'))
      }
      callback()
    }
    return {
      bankList: [],
      singleDisbursementForm: {
        code: null,
        beneficiary_account_type: 'BANK',
        account_no: null,
        beneficiary_type: null,
        beneficiary_category: null,
        mfa_code: '',
        iban: null,
        swift_code: null,
        bank_address: null,
        en_first_name: null,
        en_last_name: null,
        local_first_name: null,
        local_last_name: null
      },
      submiting: false,
      reference_batch_no: null
    }
  },
  computed: {
    beneficiaryAccountType() {
      const allOptions = beneficiaryAccountType()
      // RU 国家返回 BANK、SBP 和 EWALLET
      if (this.$store.getters.curCountry.country_code === 'RU') {
        return allOptions.filter(item => item.value === 'BANK' || item.value === 'SBP' || item.value === 'EWALLET')
      }
      // 阿联酋国家返回 BANK 和 EWALLET
      if (this.$store.getters.curCountry.country_code === 'AE') {
        return allOptions.filter(item => item.value === 'BANK' || item.value === 'EWALLET')
      }
      // 泰国返回 BANK 和 PROMPTPAY
      return allOptions.filter(item => item.value === 'BANK' || item.value === 'PROMPTPAY')
    },
    // 是否是泰国 PROMPTPAY
    isTHPromptPay() {
      return this.$store.getters.curCountry.country_code === 'TH' && this.singleDisbursementForm.beneficiary_account_type === 'PROMPTPAY'
    },
    // 阿联酋国家 + 收款账户类型选择 EWALLET
    isAEWalletType() {
      return this.$store.getters.curCountry.country_code === 'AE' && this.singleDisbursementForm.beneficiary_account_type === 'EWALLET'
    },
    // 是否显示收款账户类型下拉框
    showBeneficiaryAccountType() {
      // 泰国和RU显示收款账户类型下拉框
      // 阿联酋国家根据收款渠道类型自动设置，不需要用户选择
      return this.$store.getters.curCountry.country_code === 'TH' || this.isRUCountry
    },
    // 是否显示收款人类别下拉框
    showBeneficiaryType() {
      return this.isTHPromptPay || this.isAEWalletType || this.isRUCountry
    },
    // 是否显示收款渠道下拉框
    showReceivingChannel() {
      // 泰国 PROMPTPAY 不显示
      if (this.$store.getters.curCountry.country_code === 'TH' && this.singleDisbursementForm.beneficiary_account_type !== 'BANK') {
        return false
      }
      // RU CARD_NUMBER 不显示
      if (this.isRUCountry && this.singleDisbursementForm.beneficiary_type === 'CARD_NUMBER') {
        return false
      }
      return true
    },
    // 收款人类别 label
    beneficiaryTypeLabel() {
      return this.$t('merchantAccount.beneficiary_type')
    },
    // 收款人类别选项
    beneficiaryTypeOptions() {
      if (this.isRUCountry) {
        // SBP 时收款人类别只能是 MOBILE_NUMBER
        if (this.singleDisbursementForm.beneficiary_account_type === 'SBP') {
          return beneficiaryType().filter(item => item.value === 'MOBILE_NUMBER')
        }
        // EWALLET 时收款人类别只能是 EWALLET_ID
        if (this.singleDisbursementForm.beneficiary_account_type === 'EWALLET') {
          return [
            { label: this.$t('merchantAccount.account_type_ewallet_id'), value: 'EWALLET_ID' }
          ]
        }
        // BANK 时收款人类别为 BANK_ACCOUNT + CARD_NUMBER
        return beneficiaryType().filter(item => item.value === 'BANK_ACCOUNT' || item.value === 'CARD_NUMBER')
      }
      if (this.isAEWalletType) {
        // 阿联酋钱包类型选项
        return [
          { label: this.$t('merchantAccount.account_type_mobile_number'), value: 'MOBILE_NUMBER' },
          { label: this.$t('merchantAccount.account_type_ewallet_id'), value: 'EWALLET_ID' }
        ]
      }
      // 泰国 PROMPTPAY 选项
      return beneficiaryType().filter(item => item.value === 'NATIONAL_ID' || item.value === 'MOBILE_NUMBER')
    },
    beneficiaryCategoryOptions() {
      return [
        { label: this.$t('merchantAccount.beneficiary_category_individual'), value: 'INDIVIDUAL' },
        { label: this.$t('merchantAccount.beneficiary_category_organization'), value: 'ORGANIZATION' }
      ]
    },
    getStandardPaymentLimitMapMobileLength() {
      return function(value) {
        return this.standardPaymentLimitMap(value)?.mobileLength
      }
    },
    getStandardPaymentLimitMapLabel() {
      return function(value) {
        return this.standardPaymentLimitMap(value)?.label
      }
    },
    amountTips() {
      return `${this.$t('components.amount')} (${this.$t('tips.standard_payment_limit')} ${this.getStandardPaymentLimitMapLabel(this.$store.getters.curCountry.country_code)} ${this.$store.getters.curCountry.currency})`
    },
    isGulfCountry() {
      // 暂时只针对沙特
      return this.$store.getters.curCountry.country_code === 'SA'
      // return GULF_USD_ONLY_COUNTRY_CODES.includes(this.$store.getters.curCountry.country_code)
    },
    isRUCountry() {
      return this.$store.getters.curCountry.country_code === 'RU'
    },
    receivingChannelList() {
      if (!this.isRUCountry) {
        return this.bankList
      }
      const { beneficiary_account_type: accountType } = this.singleDisbursementForm
      const bankType = accountType === 'EWALLET' ? 2 : 1
      return this.bankList.filter(item => {
        if (Number(item.bank_type) !== bankType) {
          return false
        }
        // bank_type=1 时，只返回俄罗斯代付支持的新 code 列表（即以 RUS 开头的 code）
        return bankType !== 1 || String(item.bank_code).startsWith('RUS')
      })
    }
  },
  created() {
    this.getAllBank()
  },
  methods: {
    standardPaymentLimitMap(value) {
      const map = {
        PH: {
          value: 'PH',
          label: '50,000',
          mobileLength: 11,
          amount: 50000
        },
        TH: {
          value: 'TH',
          label: '50,000',
          mobileLength: 10,
          amount: 50000
        },
        ID: {
          value: 'ID',
          label: '250,000,000',
          mobileLength: 13,
          amount: 250000000
        },
        AE: {
          value: 'AE',
          label: '55,000',
          mobileLength: 10,
          amount: 55000
        },
        MY: {
          value: 'MY',
          label: '50,000',
          mobileLength: 11,
          amount: 50000
        },
        SA: {
          value: 'SA',
          label: '37,500',
          mobileLength: 10,
          amount: 37500
        },
        RU: {
          value: 'RU',
          label: '250,000',
          mobileLength: 10,
          amount: 250000
        },
        VN: {
          value: 'VN',
          label: '200,000,000',
          minLabel: '10,000',
          mobileLength: null,
          amount: 200000000,
          minAmount: 10000
        }
      }
      return map[value]
    },
    initEnterSingleStandardPayoutContent() {
      this.initContent()
      this.getReferenceBatchNo()
    },
    initContent() {
      this.reference_batch_no = null
      this.singleDisbursementForm = {
        code: null,
        beneficiary_account_type: 'BANK',
        account_no: null,
        beneficiary_type: null,
        beneficiary_category: null,
        iban: null,
        swift_code: null,
        bank_address: null,
        en_first_name: null,
        en_last_name: null,
        local_first_name: null,
        local_last_name: null
      }
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate()
      })
    },
    getReferenceBatchNo() {
      return fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
        }
      })
    },
    clearValidate(formName) {
      this.$nextTick(function() {
        this.$refs[formName].clearValidate()
      })
    },
    getAllBank() {
      fetchDisbursementAllCodeList().then(res => {
        if (res.code === 10000) {
          const list = res.data
          list.map(item => {
            item.name_with_full_bank = item.bank_code
            if (item.bank_type === this.BANK) {
              item.name_with_full_bank = item.bank_code + ' - ' + item.full_name
            }
            return item
          })
          this.bankList = list
        }
      })
    },
    async onClickSubmitBtn() {
      // if (!this.reference_batch_no) {
      await this.getReferenceBatchNo()
      // }
      await this.$refs.singleDisbursementForm.validate((valid) => {
        if (valid) {
          // 阿联酋国家：收款人名称+受益人地址不能超过140字符
          if (this.$store.getters.curCountry.country_code === 'AE') {
            const accountName = this.singleDisbursementForm.account_name || ''
            const beneficiaryAddress = this.singleDisbursementForm.beneficiary_address || ''
            if ((accountName.length + beneficiaryAddress.length) > 140) {
              this.$message.error(this.$t('tips.beneficiary_address_name_exceed_140'))
              return
            }
          }
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.submiting = true
            const params = { ...this.singleDisbursementForm }
            const countryCode = this.$store.getters.curCountry.country_code
            params.amount = countryCode === 'ID' ? +params.amount : Number(params.amount).toFixed(2)
            params.reference_batch_no = this.reference_batch_no
            if (params.account_no) {
              params.account_no = params.account_no.trim()
            }
            if (params.account_name) {
              params.account_name = params.account_name.trim()
            }
            // 泰国 PROMPTPAY 不需要传收款渠道
            if (this.$store.getters.curCountry.country_code === 'TH' && params.beneficiary_account_type === 'PROMPTPAY') {
              delete params.code
            }
            // RU: CARD_NUMBER 不需要传收款渠道
            if (this.isRUCountry && params.beneficiary_type === 'CARD_NUMBER') {
              delete params.code
            }
            // 选择 BANK 时不需要传收款人类别（RU 国家除外）
            if (params.beneficiary_account_type === 'BANK' && !this.isRUCountry) {
              delete params.beneficiary_type
            }
            // beneficiary_category 仅俄罗斯场景传递
            if (!this.isRUCountry) {
              delete params.beneficiary_category
            }

            addSingleDisbursement(params).then(res => {
              if (res.code === 10000) {
                this.dialogVisible = false
                this.singleDisbursementForm = {
                  code: null,
                  account_no: null
                }
                this.$message.success('Submit SuccessFully')
                this.$emit('closeModal')
                this.$emit('updateList')
              }
            }).finally(() => {
              setTimeout(() => {
                this.submiting = false
              }, 500)
            })
          })
        }
      })
    },
    onClickCancelBtn() {
      this.$emit('closeModal')
      this.$emit('showChooseModal')
    },
    disbursementChannelChange() {
      if (this.singleDisbursementForm.code) {
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['code'])
        })
      }
      this.singleDisbursementForm.account_no = null
      // RU 国家不清除收款人类别（由收款账户类别控制）
      if (!this.isRUCountry) {
        this.singleDisbursementForm.beneficiary_type = null
      }
      // 阿联酋国家根据收款渠道类型自动设置收款账户类型
      if (this.$store.getters.curCountry.country_code === 'AE') {
        const selectedBank = this.bankList.find(item => item.bank_code === this.singleDisbursementForm.code)
        if (selectedBank) {
          // bank_type === 2 钱包类型 → EWALLET
          // bank_type === 1 银行类型 → BANK
          this.singleDisbursementForm.beneficiary_account_type = selectedBank.bank_type === 2 ? 'EWALLET' : 'BANK'
        } else {
          this.singleDisbursementForm.beneficiary_account_type = null
        }
      }
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate(['account_no', 'beneficiary_type', 'beneficiary_account_type'])
      })
    },
    beneficiaryTypeChange() {
      if (this.singleDisbursementForm.beneficiary_type) {
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['beneficiary_type'])
        })
      }
      this.singleDisbursementForm.account_no = null
      // RU: 收款人类别为 CARD_NUMBER 时清除收款渠道
      if (this.isRUCountry && this.singleDisbursementForm.beneficiary_type === 'CARD_NUMBER') {
        this.singleDisbursementForm.code = null
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['code'])
        })
      }
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate(['account_no'])
      })
    },
    beneficiaryAccountTypeChange() {
      if (this.singleDisbursementForm.beneficiary_account_type) {
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['beneficiary_account_type'])
        })
      }
      this.singleDisbursementForm.beneficiary_type = null
      if (this.isRUCountry) {
        // RU: SBP 时收款人类别自动设置为 MOBILE_NUMBER
        if (this.singleDisbursementForm.beneficiary_account_type === 'SBP') {
          this.singleDisbursementForm.beneficiary_type = 'MOBILE_NUMBER'
        }
        // RU: EWALLET 时收款人类别自动设置为 EWALLET_ID
        if (this.singleDisbursementForm.beneficiary_account_type === 'EWALLET') {
          this.singleDisbursementForm.beneficiary_type = 'EWALLET_ID'
        }
        // 账户类型变化后，清除不属于当前渠道类型的已选收款渠道
        const selectedChannelIsAvailable = this.receivingChannelList.some(item => item.bank_code === this.singleDisbursementForm.code)
        if (!selectedChannelIsAvailable) {
          this.singleDisbursementForm.code = null
        }
      }
      this.singleDisbursementForm.account_no = null
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate(['beneficiary_type', 'account_no', 'code'])
      })
    }
  }
}
</script>

<style scoped>
.select-item{
  width:100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.cancel-btn {
  width: 213px;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: #FFFFFF;
  background-color: #98a1b4;
}
.confirm-btn {
  width: 213px;
  height: 44px;
  margin-left: 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
}
.cp-btn {
  width: 475px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.payout-second-title {
  font-size: 18px;
  color: #000000;
}
.mt-12{
  margin-top: 14px
}
</style>
